import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, normalizeClass as _normalizeClass, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "batch-loader__types" }
const _hoisted_2 = { class: "batch-loader" }
const _hoisted_3 = { class: "batch-loader__results" }
const _hoisted_4 = { class: "batch-loader__statistics" }
const _hoisted_5 = { class: "label-m" }
const _hoisted_6 = { class: "batch-loader_selected" }
const _hoisted_7 = { class: "label-m" }
const _hoisted_8 = { class: "batch-loader_uploaded" }
const _hoisted_9 = { class: "label-m" }
const _hoisted_10 = { class: "batch-loader_errors" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "flex-expander" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NButtonGroup = _resolveComponent("NButtonGroup")!
  const _component_NButton = _resolveComponent("NButton")!
  const _component_BatchLoaderModalImages = _resolveComponent("BatchLoaderModalImages")!
  const _component_BatchLoaderModalCsv = _resolveComponent("BatchLoaderModalCsv")!
  const _component_NLoadingProgress = _resolveComponent("NLoadingProgress")!
  const _component_BatchUploadLogsDownload = _resolveComponent("BatchUploadLogsDownload")!
  const _component_ItemsNavigation = _resolveComponent("ItemsNavigation")!
  const _component_BatchLoaderModalResult = _resolveComponent("BatchLoaderModalResult")!
  const _component_NModalWindow = _resolveComponent("NModalWindow")!

  return (_openBlock(), _createBlock(_component_NModalWindow, {
    layout: true,
    className: "batch-loader__modal",
    customSize: "1000px",
    "close-icon": true,
    "keyboard-close-disabled": "",
    onClose: _ctx.close
  }, _createSlots({
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_NButtonGroup, {
          modelValue: _ctx.model.objectType,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = (v) => _ctx.setObjectType(v)),
          items: _ctx.dataAssetsModule.eventObjectTypeButtonItems,
          disabled: _ctx.loading
        }, null, 8, ["modelValue", "items", "disabled"]),
        (_ctx.model.objectType === 'cars')
          ? (_openBlock(), _createBlock(_component_NButtonGroup, {
              key: 0,
              modelValue: _ctx.model.inputType,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = (v) => _ctx.setInputType(v)),
              items: _ctx.inputTypeItems,
              disabled: _ctx.loading
            }, null, 8, ["modelValue", "items", "disabled"]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_NButton, {
        icon: "close",
        type: "secondary",
        round: "",
        onClick: _ctx.close
      }, null, 8, ["onClick"])
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.realInputType === 'images')
            ? (_openBlock(), _createBlock(_component_BatchLoaderModalImages, {
                key: 0,
                batchModule: _ctx.batchModule
              }, null, 8, ["batchModule"]))
            : _createCommentVNode("", true),
          (_ctx.realInputType === 'csv')
            ? (_openBlock(), _createBlock(_component_BatchLoaderModalCsv, {
                key: 1,
                batchModule: _ctx.batchModule
              }, null, 8, ["batchModule"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_3, [
          (_ctx.resultItems.length)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_NLoadingProgress, {
                  percent: _ctx.totalStatistics.progress,
                  errorPercent: _ctx.totalStatistics.errorPercent
                }, null, 8, ["percent", "errorPercent"]),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createTextVNode(_toDisplayString(_ctx.$t('cards.selected', 'f')) + ": ", 1),
                    _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.resultItems.length), 1)
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createTextVNode(_toDisplayString(_ctx.$t('cards.uploaded', 'f')) + ": ", 1),
                    _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.totalStatistics.uploaded), 1)
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createTextVNode(_toDisplayString(_ctx.$t('cards.errors', 'f')) + ": ", 1),
                    _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.totalStatistics.errors), 1)
                  ]),
                  (_ctx.batchModule.uploadList)
                    ? (_openBlock(), _createBlock(_component_BatchUploadLogsDownload, {
                        key: 0,
                        item: _ctx.batchModule.uploadList
                      }, null, 8, ["item"]))
                    : _createCommentVNode("", true),
                  _hoisted_11,
                  _createVNode(_component_ItemsNavigation, { state: _ctx.navigationState }, null, 8, ["state"])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navigationState.items, (result) => {
                  return (_openBlock(), _createBlock(_component_BatchLoaderModalResult, {
                    key: result.id,
                    item: result,
                    "card-type": _ctx.cardType,
                    onOpenCard: _ctx.openCard
                  }, null, 8, ["item", "card-type", "onOpenCard"]))
                }), 128))
              ], 64))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 2
  }, [
    (!_ctx.finished)
      ? {
          name: "footer",
          fn: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(["batch-loader__buttons", { 'batch-loader_fix': _ctx.resultItems.length }])
            }, [
              _createVNode(_component_NButton, {
                type: "primary",
                size: "big",
                onClick: _ctx.batchUpload,
                disabled: _ctx.resultItems.length === 0 || _ctx.loading
              }, {
                default: _withCtx(() => [
                  (_ctx.batchModule.paused)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(_ctx.$t('cards.continue', 'f')), 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(_ctx.$t('cards.start', 'f')), 1)
                      ], 64))
                ]),
                _: 1
              }, 8, ["onClick", "disabled"]),
              (_ctx.loading)
                ? (_openBlock(), _createBlock(_component_NButton, {
                    key: 0,
                    type: "secondary",
                    size: "big",
                    onClick: _ctx.pauseUpload
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('cards.pause', 'f')), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ], 2)
          ])
        }
      : undefined
  ]), 1032, ["onClose"]))
}